import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"
import { get } from "@rails/request.js"
import { restartCssAnimations } from "../utils/restart_css_animations"

// Opens associate picker modals via GET + turbo-stream (no Turbo hidden-form POST).
export default class extends Controller {
  async open(event) {
    event.preventDefault()

    const url = event.currentTarget.href
    if (!url) return

    this._showLoadingModal()

    try {
      const response = await get(url, { responseKind: "turbo-stream" })
      if (response.ok) {
        Turbo.renderStreamMessage(await response.text())
      } else {
        this._resetModalFrame()
      }
    } catch {
      this._resetModalFrame()
    }
  }

  _showLoadingModal() {
    const frame = document.getElementById("modal")
    const template = document.getElementById("associate-modal-loading-template")
    if (!frame || !template) return

    this._resetModalFrame()
    frame.innerHTML = template.innerHTML

    // modal_controller#connect will show the dialog; also restart after paint in
    // case shown.bs.modal already fired before our listener attached.
    requestAnimationFrame(() => {
      const modalEl = frame.querySelector(".modal")
      if (!modalEl) return
      const restart = () => restartCssAnimations(modalEl)
      if (modalEl.classList.contains("show")) {
        restart()
      } else {
        modalEl.addEventListener("shown.bs.modal", restart, { once: true })
      }
    })
  }

  _resetModalFrame() {
    const frame = document.getElementById("modal")
    if (!frame) return

    frame.querySelectorAll(".modal").forEach((modalEl) => {
      const instance = Modal.getInstance(modalEl)
      if (instance) {
        instance.hide()
        instance.dispose()
      }
    })

    frame.innerHTML = ""
    this._cleanupModalBodyState()
  }

  _cleanupModalBodyState() {
    if (!document.body.classList.contains("modal-open")) return

    document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove())
    document.body.classList.remove("modal-open")
    document.body.style.removeProperty("overflow")
    document.body.style.removeProperty("padding-right")
  }
}
